import OrganizationTable from "@/components/admin/orgs/table";
import UserTable from "@/components/admin/users/table";
import { Button } from "@papier/ui/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@papier/ui/components/ui/card";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Building2, Users } from "lucide-react";

export const Route = createFileRoute("/admin/")({
  component: AdminIndex,
});

function AdminIndex() {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      <Card>
        <CardHeader>
          <CardTitle>Recent Users</CardTitle>
          <CardDescription>Latest user activity</CardDescription>
        </CardHeader>
        <CardContent>
          <UserTable filters={{ page: 1, limit: 5 }} view="index" />
        </CardContent>
        <CardFooter className="mt-auto">
          <Button asChild className="ml-auto" variant="outline">
            <Link to="/admin/users">
              <Users />
              View All Users
            </Link>
          </Button>
        </CardFooter>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle>Recent Organizations</CardTitle>
          <CardDescription>Latest organization activity</CardDescription>
        </CardHeader>
        <CardContent>
          <OrganizationTable filters={{ page: 1, limit: 5 }} view="index" />
        </CardContent>
        <CardFooter>
          <Button asChild className="ml-auto" variant="outline">
            <Link to="/admin/organizations">
              <Building2 />
              View All Organizations
            </Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
